import { Auditable, Case, QueryParams, SortParams } from "..";

export interface RecoveryAppImport extends Auditable {
    caseId?: number;
    data: any; // TODO: this may be strongly typed if helpful going forward
    filePath?: string;
    syncedOn?: string;
    syncedByUserId?: number;

    case?: Case;
}

export const DefaultRecoveryAppImportQueryParams: QueryParams = {
    territoryIds: "",
    referralNumber: "",
};

export const DefaultRecoveryAppImportSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "true",
};
